// Translate backend / hardcoded English error messages to the current language.
import { getT } from "@/lib/i18n";

function currentLang() {
  try { return localStorage.getItem("metazik_lang") || "fr"; }
  catch { return "fr"; }
}

export function translate(message) {
  if (!message) return "";
  const dict = getT(currentLang()).errors || {};
  return dict[message] || message;
}

// Short alias for use in toast / catch blocks.
export const tr = translate;
